// This file serves as a root to combine all custom middleware so they don't bloat the store.ts file size
import { logMessageMiddleware } from 'TutorBotChat';
// Import directly from sync module to avoid loading components/hooks
// which have Angular dependencies that cause issues in test environments
import { appHeaderSyncMiddleware } from 'AppHeaderReact/sync';

export const customMiddleware = [logMessageMiddleware, appHeaderSyncMiddleware];

export default customMiddleware;
